import { useState, useEffect } from 'react';

export const useSourceTracking = () => {
  const [tracking, setTracking] = useState({
    pageURL: window.location.href,
    referrer: document.referrer || 'direct',
    source: 'Jewellery Landing Page',
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sourceParam = params.get('source') || params.get('utm_source');
    
    setTracking({
      pageURL: window.location.href,
      referrer: document.referrer || 'direct',
      source: sourceParam || 'Jewellery Landing Page',
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
    });
  }, []);

  return tracking;
};